@if (!isDataAvailable() && !isLoading) {
  <div class="flex-container"
    fxLayout="row"
    fxLayoutAlign="center center"
    >
    <data-table-error [errorText]="noResultsMessage"
      [actionableText] = "actionableErrorText"
      [isVisibleDeepLinkMsg]="isVisibleDeepLinkMsg"
      [deepLinkMessage]="deepLinkMessage"
      (deepLinkMessageClick)="onClickDeepLinkMsg()"
      (textClick)="errorTextClicked()">
    </data-table-error>
  </div>
}
@if (isLoading) {
  <div
    class="ngx-data-table__loading"
    [ngClass]="{'ngx-data-table__loading-data' : !isDataAvailable()}"
    [cfaLoading]="true">
  </div>
}
@if (isDataAvailable()) {
  <div>
    @for (row of rows; track trackRow($index, row); let i = $index) {
      <div class="flex-container ngx-data-table__row"
       [ngClass]="{'ngx-data-table__small-row' : useSmallRowSize,
                   'ngx-data-table__row-hover' : !isRowNonInteractive(row),
                   'ngx-data-table__row-bottom-border' : row.bottomBorder,
                   'ngx-data-table__blue-row-background' : (i % 2 !== 0)}"
        fxLayout="row wrap"
        [id]="row[rowId]">
        <div fxLayout="row" fxFlex="100">
          <div class="flex-item"
            [fxFlex]="getFlex()">
            @if (showCheckboxes) {
              <div>
                @if (showCheckboxes && !isDetailView && !shouldDisableRow(row)) {
                  <mat-checkbox [(ngModel)]="row.state"
                    [disabled]="disableCheckbox || isLoading"
                    (change)="checkboxClick(row)"
                    [attr.data-testid]="i + '-table-checkbox'"
                    class="ngx-data-table__checkbox">
                  </mat-checkbox>
                }
              </div>
            }
          </div>
          @for (col of columns; track trackColumn($index, col)) {
            @if (!col.hide) {
              <span
                class="flex-item ngx-data-table__cell"
              [ngClass]="{'ngx-data-table__row-disabled': (shouldDisableRow(row) || disableCheckbox),
                          'ngx-data-table__center-column': col.centerContent}"
                [fxFlex]="getColSize(col)"
                (click)="rowClicked(row)"
                (keydown.enter)="$event.target === $event.currentTarget && (rowClicked(row))">
                <data-table-cell [row]="row"
                  [col]="col"
                  [disableDeleteIcon]="disableDeleteIcon"
                  [shouldDisableButton]="shouldDisableRow(row)"
                  [isEnableSignatureMembership]="isEnableSignatureMembership"
                  (onButtonClick)="buttonClicked(row, col.id)"
                  (onExternalLinkClick)="externalLinkClicked(row)"
                  (onDeleteClick)="deleteClicked(row)"
                  (onOrderNumberClicked)="orderNumberClicked(row)"
                  (onViewNotesClick)="viewNotesClicked(row)">
                </data-table-cell>
              </span>
            }
          }
          @if (isDetailView) {
            <div>
              @if (isDetailView && !row.open) {
                <button
                  type="button"
                  class="ngx-data-table__chevron-button"
                  aria-expanded="false"
                  (click)="openDetail(row)">
                  <img
                    alt="Chevron Icon Facing Down"
                    class="ngx-data-table__chevron-icon-down"
                    src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
                </button>
              }
              @if (isDetailView && row.open) {
                <button
                  type="button"
                  class="ngx-data-table__chevron-button"
                  aria-expanded="true"
                  (click)="openDetail(row)">
                  <img
                    alt="Chevron Icon Facing Up"
                    class="ngx-data-table__chevron-icon-up"
                    src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
                </button>
              }
            </div>
          }
          @if (!shouldHideChevron(row) && !shouldDisplayInfo(row)) {
            <button
              type="button"
              fxFlex="25px"
              class="ngx-data-table__chevron-button"
              (click)="rowClicked(row)">
              <img alt="Chevron Icon"
                class="ngx-data-table__chevron-icon"
                src="https://www.cfacdn.com/img/Spotlight/Icons/NavyChevronRounded_Icon.png"/>
            </button>
          }
          @if (shouldHideChevron(row) && !shouldDisplayInfo(row)) {
            <div fxFlex="25px"></div>
          }
          @if (shouldDisplayInfo(row)) {
            <div fxFlex="25px" class="ngx-data-table__info-icon" >
              <help-text [helpText]="getRowDisplayInfo(row)" [displayOnLeft]=true></help-text>
            </div>
          }
        </div>
        @if (row.isNoteOpen) {
          <div
            fxLayout="row wrap"
            fxFlex="100">
            @for (note of row[noteProp]; track trackNote($index, note)) {
              <div fxLayout="row"
                fxFlex="100"
                >
                <div class="ngx-data-table__note">
                  <div>
                    <span class="ngx-data-table__note-name">{{note.updatedBy}}</span>
                    <span class="ngx-data-table__note-date"> - {{note.updatedAt | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}</span>
                  </div>
                  <div class="ngx-data-table__note-text">{{note.note}}</div>
                </div>
              </div>
            }
          </div>
        }
        @if (isDetailView && row.open) {
          <div
            fxLayout="row wrap"
            fxFlex="100">
            <div fxLayout="row"
              fxFlex="100"
              class="ngx-data-table__detail-header">
              <span fxFlex="425px"></span>
              @for (detRowCol of detailColumns; track trackColumn($index, detRowCol)) {
                <div fxFlex>
                  {{detRowCol.title}}
                </div>
              }
            </div>
            @for (detRow of row[detailProp]; track trackDetailRow($index, detRow)) {
              <div fxLayout="row"
                fxFlex="100"
                >
                <span fxFlex="425px"></span>
                @for (detCol of detailColumns; track trackColumn($index, detCol)) {
                  <div fxFlex>
                    <data-table-cell [row]="detRow"
                      [col]="detCol"
                      [shouldDisableButton]= "shouldDisableRow(row)"
                      (onButtonClick)="buttonClicked(row)"
                      (onExternalLinkClick)="externalLinkClicked(row)"
                      (onDeleteClick)="deleteClicked(row)">
                    </data-table-cell>
                  </div>
                }
              </div>
            }
            @if (row.doorDash) {
              <div fxLayout="row"
                fxFlex="100"
                >
                <div fxFlex="55px"></div>
                <div fxFlex="16"></div>
                <div fxFlex class="ngx-data-table__notes">
                  {{detailViewNoteText}}
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
